import { Popover } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import PRZText from '../../../Common/UI/PRZText';

const ListScreenKeys = ({
  documentData,
}) => {
  const record = documentData;

  const gateDocumentNumber = () => {
    const gateDocNumber = record?.ref_gate_document;

    if (!gateDocNumber) return '-';

    const otherDocs = (
      <div>
        {
          gateDocNumber?.slice(2).map((document, i) => (
            <div className="other-uom-stock" key={i}>
              <div
                // onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
              >
                {document?.gate_document_number}
              </div>
            </div>
          ))
        }
      </div>
    );
    return (
      <Popover
        placement="bottom"
        content={gateDocNumber?.length > 2 && otherDocs}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <div style={{
          fontWeight: 600,
          color: '#1890FF',
        }}
        >
          {gateDocNumber?.slice(0, 2)?.map((document) => (
            <Link
              // to={`/logistic/gate-document/view/${document?.gate_document_id}`}
              // target="_blank"
              key={document?.gate_document_id}
            >
              <PRZText text={document?.gate_document_number} />
            </Link>
          ))}
          {gateDocNumber?.length > 2 && (
            <PRZText
              className="table-subscript-grey"
              text={`and ${gateDocNumber.length - 2} more`}
            />
          )}
        </div>
      </Popover>
    );
  };

  return [
    {
      label: 'Items',
      value: record?.line_count || 0,
    },
    {
      label: 'Gate Document Number',
      value: gateDocumentNumber(),
    },
    {
      label: 'Created Date',
      value: (
        <React.Fragment>
          <PRZText text={dayjs(record?.created_at).format('DD/MM/YYYY')} />
          <PRZText text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
        </React.Fragment>
      ),
    },
  ];
};

export default ListScreenKeys;
